/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { CreateServiceActions, CreateServiceActionTypes, CreateServiceState } from './types';

export const initialState: CreateServiceState = {
  isOpen: false,
};

export function createService(state = initialState, action: CreateServiceActionTypes): CreateServiceState {
  switch (action.type) {
    case CreateServiceActions.OPEN_CREATE_SERVICE_OVERLAY: {
      const { organizationId, projectId, clusterId } = action.payload;
      return { ...state, isOpen: true, organizationId, projectId, clusterId };
    }
    case CreateServiceActions.CLOSE_CREATE_SERVICE_OVERLAY:
      return { ...state, isOpen: false };
    default:
      return state;
  }
}
